const getBaseUrl = (): string => {
  const base = document.getElementsByTagName('base')[0];
  const hrefAttribute = base.getAttribute('href');
  return hrefAttribute === null ? '' : hrefAttribute;
};

export default getBaseUrl;
